import { Component, OnInit } from '@angular/core';
import { SnackBarService } from './snack-bar.service';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  animations: [
    trigger('visibility', [
      state('show', style({
        display: 'block',
        opacity: '1',
        transform: 'translate(-50%, 100px)'
      })),
      state('hide', style({
        display: 'none',
        opacity: '0',
        transform: 'translate(-50%, 0px)'
      })),
      transition('show => hide', animate('300ms ease-in')),
      transition('hide => show', animate('100ms ease-out'))
  ])]
})
export class SnackBarComponent implements OnInit {

  state = 'hide';
  display: boolean;
  message: string;
  type;

  constructor( private snackBarService: SnackBarService ) {
    this.snackBarService.listen().subscribe(
      (res) => {
        this.display = true;
        this.type = res['type'];
        this.message = res['message'];
        this.state = 'show';
        setTimeout(() => { this.state = 'hide'; }, 2000);
    });
  }

  ngOnInit() { }
}
